import { RANK_DISPLAY_MAP } from "@/src/constants/StatsCornerConstants";

export const PlayingCards = ({ cards, isCommunity }) => {
  const cardFillArr = isCommunity
    ? Array.from({ length: 5 }, (_, index) => cards[index]?.trim() ?? "hidden")
    : cards;

  return (
    <div className="flex justify-start items-center">
      {cardFillArr.map((cardString, index) => (
        <Card key={index} cardString={cardString} index={index} />
      ))}
    </div>
  );
};

const Card = ({ cardString, index }) => {
  const style = {
    transform: `translateX(${index * -2.5}px)`,
    transition: "transform 0.2s ease-in-out",
    boxShadow: "-2px 0px 4px 0px #00000040",
  };

  if (cardString === "hidden") {
    return (
      <div
        className={`w-3.75 h-5 bg-red-500 border border-white rounded-xs shadow-2xl flex items-center justify-center`}
        style={style}
      ></div>
    );
  }
  const suitCode = cardString.charAt(0);
  const rankCode = RANK_DISPLAY_MAP[cardString.slice(1)];

  // Mapping for suit symbols and colors
  const suitMap = {
    h: { symbol: "♥", color: "text-red-600" }, // Hearts
    d: { symbol: "♦", color: "text-red-600" }, // Diamonds
    c: { symbol: "♣", color: "text-gray-900" }, // Clubs
    s: { symbol: "♠", color: "text-gray-900" }, // Spades
  };

  const { symbol, color } = suitMap[suitCode] || {
    symbol: "?",
    color: "text-gray-500",
  };

  return (
    <div
      className={` w-3.75 h-5 bg-white rounded-xs shadow-2xl flex flex-col gap-0.5 items-center justify-between p-0.5`}
      style={style}
    >
      <div className={`text-[7px] leading-none font-bold ${color}`}>
        {rankCode}
      </div>
      <div className={`leading-none text-[7px] ${color}`}>{symbol}</div>
    </div>
  );
};
